import Accordion, { AccordionContext } from "@components/accordion/Accordion";
import { motion } from "framer-motion";
import { BiChevronRight } from "react-icons/bi";
import { useContext } from "react";

const FaqHeader = ({ question }: { question: string }) => {
	const { isOpen, toggleOpen } = useContext(AccordionContext);

	return (
		<div
			className="help-center__faq-header"
			onClick={() => toggleOpen()}
			role="button"
			tabIndex={0}
			onKeyDown={(e) => {
				if (e.key === "Enter" || e.key === " ") {
					e.preventDefault();
					toggleOpen();
				}
			}}
		>
			<motion.div
				animate={{ rotate: isOpen ? 90 : 0 }}
				className="d-flex align-items-center"
			>
				<BiChevronRight size={20} color="rgba(28, 27, 31, 0.5)" />
			</motion.div>
			<span className="ff-medium fs-13">{question}</span>
		</div>
	);
};

const FaqAccordionItem = ({
	question,
	answer,
}: {
	question: string;
	answer: string;
}) => (
	<div className="help-center__faq-item">
		<Accordion header={<FaqHeader question={question} />} initiallyOpen={false}>
			<p className="help-center__faq-answer fs-13 ff-light">{answer}</p>
		</Accordion>
	</div>
);

export default FaqAccordionItem;
